import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { isMobile, isTablet } from 'react-device-detect';
import { IOrderDeliveryTask } from '../../../interfaces/delivery-company/tasks';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import ItemsCount from '../../common/labels-input/items-count/items-count';
import DeliveryTaskPage from './delivery-task-page';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import DeliveryTaskQuickScanDialog from '../quick-scan-dialogs/delivery-task-dialog';

interface OrderProps {
  task: IOrderDeliveryTask;
  onClose: () => void;
  setSnackBarResult: (t?: timestampedMessage) => void;
  reloadTasks: () => void;
}

function TaskDialog({
  task,
  onClose,
  setSnackBarResult,
  reloadTasks,
}: OrderProps) {
  function handleDialogClose(snackbar?: timestampedMessage) {
    setSnackBarResult(snackbar);
    onClose();
  }

  return (
    <CustomDialog
      open={true}
      onClose={onClose}
      fullWidth
      fullScreen={(isMobile && !isTablet)}
      maxWidth="xl"
    >
      <DialogContent>
        <Typography variant="h3" textAlign="center">
          Task #{task.id}
        </Typography>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <ItemsCount label={`# items: ${task?.order.number_of_packages}`} />
        </div>
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
          }}
        >
          <IconButton onClick={onClose}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>
        <DeliveryTaskQuickScanDialog
          packageId={task.order.id + '0000'}
          onClose={onClose}
        />
        {/* <DeliveryTaskPage taskId={task.id} onTaskScan={handleDialogClose} reloadTasks={reloadTasks} /> */}
      </DialogContent>
    </CustomDialog>
  );
}

export default TaskDialog;
